import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/Layout/Layout.vue';
import Login from '../views/Login';

Vue.use(Router)

export const routes = [
  {
    path: '/dashboard',
    name: '数据看板',
    component: Layout,
    icon: 'el-icon-data-line',
    redirect: "/dashboard/index",
    children: [
      {
        path: '/dashboard/index',
        name: '数据看板',
        component: () => import('@/views/Dashboard/index.vue'),
      },
    ]
  },
  {
    path: '/system',
    name: '系统管理',
    component: Layout,
    icon: 'el-icon-setting',
    redirect: "/system/user",
    children: [
      {
        path: '/system/user',
        name: '用户管理',
        component: () => import('@/views/system/user/List.vue'),
      },
      {
        path: '/system/role',
        name: '角色管理',
        component: () => import('@/views/system/role/List.vue'),
      },
      {
        path: '/system/permission',
        name: '权限管理',
        component: () => import('@/views/system/permission/List.vue'),
      },
      {
        path: '/system/user/list',
        name: '用户列表',
        component: () => import('@/views/system/user/List.vue'),
      },
      {
        path: '/system/sms-log',
        name: '短信记录',
        component: () => import('@/views/system/SmsLog.vue'),
      }
    ],

  },
  {
    path: '/property',
    name: '物业管理',
    component: Layout,
    icon: 'el-icon-setting',
    redirect: "/property/building",
    children: [
      {
        path: '/property/building',
        name: '楼栋单元管理',
        component: () => import('@/views/property/building/List.vue'),
      },
      {
        path: '/property/house',
        name: '房间管理',
        component: () => import('@/views/property/house/List.vue'),
      },
      {
        path: '/property/park',
        name: '停车位管理',
        component: () => import('@/views/property/park/List.vue'),
      },
    ],
  },
  {
    path: '/wx',
    name: '小程序管理',
    component: Layout,
    icon: 'el-icon-setting',
    redirect: "/wx/index",
    children: [
      {
        path: '/wx/index',
        name: '小程序管理',
        component: () => import('@/views/wx/wx/List.vue'),
      },
      {
        path: '/wx/goods-display-order',
        name: '首页商品展示顺序',
        component: () => import('@/views/wx/goodsDisplayOrder/index.vue'),
      },
      {
        path: '/wx/quick-entry',
        name: '首页快捷入口',
        component: () => import('@/views/wx/quickEntry/index.vue'),
      },
    ],
  },
  {
    path: '/merchant',
    name: '商家管理',
    component: Layout,
    redirect: "/merchant/index",
    children: [
      {
        path: '/merchant/index',
        name: '商户管理',
        component: () => import('@/views/Merchant/merchant/list.vue'),
      },
      {
        path: '/merchant/goods/index',
        name: '商品管理',
        component: () => import('@/views/Merchant/goods/list.vue'),
      },
      {
        path: '/merchant/goods/category/index',
        name: '商品分类',
        component: () => import('@/views/Merchant/goodsCategory/list.vue'),
      },
      {
        path: '/merchant/goods/coupon/index',
        name: '优惠券管理',
        component: () => import('@/views/Merchant/coupon/list.vue'),
      },       {
        path: '/merchant/category/index',
        name: '商户分类',
        component: () => import('@/views/Merchant/merchantCategory/list.vue'),
      },
      {
        path: '/merchant/memberLevel/index',
        name: '会员等级',
        component: () => import('@/views/Merchant/memberLevel/list.vue'),
      },
      {
        path: '/merchant/homeNearbyItem/index',
        name: '附近购配置',
        component: () => import('@/views/Merchant/homeNearbyItem/list.vue'),
        meta: { title: '附近购配置', icon: 'el-icon-location-outline' },
      },
      {
        path: '/merchant/memberCouponRule/index',
        name: '阶梯返券规则',
        component: () => import('@/views/Merchant/memberCouponRule/list.vue'),
      },
      {
        path: '/merchant/shareCouponLog/index',
        name: '分享券日志',
        component: () => import('@/views/Merchant/shareCouponLog/list.vue'),
      },
      {
        path: '/merchant/purchaseRebateRule/index',
        name: '购买返券规则',
        component: () => import('@/views/Merchant/purchaseRebateRule/list.vue'),
      },
      {
        path: '/merchant/purchaseRebateLog/index',
        name: '购买返券日志',
        component: () => import('@/views/Merchant/purchaseRebateLog/list.vue'),
      },
      {
        path: '/merchant/timeSlot/index',
        name: '首页时段配置',
        component: () => import('@/views/Merchant/timeSlot/list.vue'),
      },
    ],
  },
  {
    path: '/points',
    name: '积分管理',
    component: Layout,
    icon: 'el-icon-star-on',
    redirect: "/points/config",
    children: [
      {
        path: '/points/config',
        name: '积分配置',
        component: () => import('@/views/Points/config/List.vue'),
      },
      {
        path: '/points/merchant',
        name: '商家积分设置',
        component: () => import('@/views/Points/merchant/List.vue'),
      },
    ],
  },
  {
    path: '/supplier',
    name: '供应商管理',
    component: Layout,
    icon: 'el-icon-truck',
    redirect: "/supplier/index",
    children: [
      {
        path: '/supplier/index',
        name: '供应商列表',
        component: () => import('@/views/Supplier/List.vue'),
      },
    ],
  },
  {
    path: '/pay',
    name: '支付配置',
    component: Layout,
    redirect: "/pay/index",
    children: [
      {
        path: '/pay/index',
        name: '支付管理',
        component: () => import('@/views/Pay/pay/list.vue'),
      },
      {
        path: '/pay/withdraw',
        name: '用户提现审核',
        component: () => import('@/views/Pay/withdraw/list.vue'),
      },
      {
        path: '/pay/merchant-withdraw',
        name: '商家提现审核',
        component: () => import('@/views/Pay/merchantWithdraw/list.vue'),
      },
      {
        path: '/pay/profit',
        name: '分账列表',
        component: () => import('@/views/Pay/profitSharing/list.vue'),
      },
      {
        path: '/pay/abnormal',
        name: '异常订单处理',
        component: () => import('@/views/Pay/abnormalOrders/list.vue'),
      },
      {
        path: '/pay/scan-commission',
        name: '扫码返券配置',
        component: () => import('@/views/Pay/scanCommission/index.vue'),
        meta: { title: '扫码返券配置', icon: 'el-icon-money' },
      },
      {
        path: '/pay/scan-commission-dashboard',
        name: '扫码返券看板',
        component: () => import('@/views/Pay/scanCommissionDashboard/index.vue'),
        meta: { title: '扫码返券看板', icon: 'el-icon-data-line' },
      },
      {
        path: '/pay/coupon-alliance',
        name: '券互通联盟',
        component: () => import('@/views/Pay/couponAlliance/index.vue'),
        meta: { title: '券互通联盟', icon: 'el-icon-link' },
      },
      {
        path: '/pay/scan-settlement-query',
        name: '扫码订单分账查询',
        component: () => import('@/views/Pay/scanSettlementQuery/index.vue'),
        meta: { title: '扫码订单分账查询', icon: 'el-icon-document' },
      },
      {
        path: '/merchant/withdraw',
        name: '商家提现',
        component: () => import('@/views/Pay/merchantWithdraw/Apply.vue'),
      },
    ]
  },
  {
    path: '/order',
    name: '订单管理',
    component: Layout,
    redirect: "/order/index",
    children: [
      {
        path: '/order/index',
        name: '订单管理',
        component: () => import('@/views/Order/list.vue'),
      },
    ]
  },
  {
    path: '/printer',
    name: '打印机管理',
    component: Layout,
    redirect: "/printer/index",
    children: [
      {
        path: '/printer/index',
        name: '打印机管理',
        component: () => import('@/views/Printer/printer/list.vue'),
      },
    ]
  },
  {
    path: '/goods/add',
    name: '添加商品',
    component: () => import('@/views/Merchant/goods/addGoods.vue')
  },
  {
    path: '/goods/edit',
    name: '编辑商品',
    component: () => import('@/views/Merchant/goods/editGoods.vue')
  },
  {
    path: '/user',
    component: Layout,
    name: '用户管理',
    icon: 'el-icon-user',
    redirect: '/user/list',
    children: [
      {
        path: '/user/list',
        component: () => import('@/views/User/List.vue'),
        name: '用户列表',
      },
    ],
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  }
]

const router = new Router({
  routes
})

// 路由守卫：未登录用户重定向到登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/') {
    // 登录页：已登录则跳转到看板
    if (token) {
      next('/dashboard/index')
    } else {
      next()
    }
  } else {
    // 其他页面：未登录则跳转到登录页
    if (!token) {
      next('/')
    } else {
      next()
    }
  }
})

export default router